<template>
  <section>
    <form method="post" @submit.prevent="send" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">新增線別</p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group
              horizontal
              name="code"
              attribute="attributes.area_code"
              :label="$t('attributes.area_code')"
            >
              <b-input
                v-model="form.code"
                name="code"
                maxlength="2"
                :placeholder="
                  $t('message.please_input') + $t('attributes.area_code')
                "
                expanded
              ></b-input>
            </form-group>
            <form-group
              horizontal
              name="name"
              attribute="attributes.area_name"
              :label="$t('attributes.area_name')"
            >
              <b-input
                v-model="form.name"
                name="name"
                maxlength="20"
                :placeholder="
                  $t('message.please_input') + $t('attributes.area_code')
                "
                expanded
              ></b-input>
            </form-group>
            <form-group horizontal name="sort" :label="$t('attributes.sort')">
              <b-select v-model="form.sort" name="sort">
                <option
                  v-for="option in sortOptions"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </b-select>
            </form-group>
            <form-group
              horizontal
              name="status"
              attribute="attributes.status"
              :label="$t('attributes.status')"
            >
              <b-switch v-model="form.status" name="status"></b-switch>
            </form-group>
          </form-wrapper>
        </section>
        <footer class="modal-card-foot">
          <b-button
            :loading="sending"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.cancel') }}
          </b-button>
          <b-button
            :loading="sending"
            class="is-fullwidth"
            type="is-primary"
            native-type="submit"
          >
            {{ $t('attributes.add') }}
          </b-button>
        </footer>
      </div>
    </form>
  </section>
</template>
<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'AreaForm',
  props: {
    isSending: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      sending: false,

      form: {
        code: '',
        name: '',
        sort: 49,
        status: true
      },

      sortOptions: [...Array(50).keys()].map(i => i + 1)
    }
  },
  validations: {
    form: {
      code: { required, maxlength: 2 },
      name: { required, maxlength: 20 },
      sort: { required },
      status: { required }
    }
  },
  methods: {
    send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('onSend', this.form)
    }
  }
}
</script>
